module.exports = __webpack_public_path__ + "static/media/photo3.d3831b95.jpg";